import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_304: DocMigration = {
  maxSchemaVersion: "0.0.304",
  description: "Edge Labels from static room layout to doc. Remove all references to static room layouts.",
  apply(json: any): any {
    const entityEdgeBehaviors: { [id: string]: any } = {};

    let count = Object.keys(json.edgeBehaviors).length;

    for (const roomId in json.staticRoomLayouts) {
      const staticRoomLayout = json.staticRoomLayouts[roomId];
      if (!staticRoomLayout) {
        continue;
      }

      const edgeLabels = staticRoomLayout?.edgeLabels;
      if (!edgeLabels?.length) {
        continue;
      }

      for (const edgeLabel of edgeLabels) {
        const id = uid();
        entityEdgeBehaviors[id] = {
          entityType: "EDGE_BEHAVIOR",
          edgeBehaviorType: "LABEL",
          sortIndex: count++,
          parentId: roomId,
          id,
          facadeId: edgeLabel.name,
          edgeId: edgeLabel.edgeId,
        };
      }

      delete staticRoomLayout.edgeLabels;
    }

    json.edgeBehaviors = { ...json.edgeBehaviors, ...entityEdgeBehaviors };

    // Cue the music and removal of staticRoomLayouts.
    delete json.staticRoomLayouts;

    // change the shape of gableEndLabels to be consistent with Label's new shape.
    for (const roofId in json.roofs) {
      const roof = json.roofs[roofId];
      if (!roof) {
        continue;
      }

      roof.gableEndLabels = roof.gableEndLabels
        ? roof.gableEndLabels?.map((label: any) => {
            return { facadeId: label.name, face: label.face };
          })
        : [];
      json.roofs[roofId] = roof;
    }

    return json;
  },
};

export default migration_0_0_304;
